import React, { useEffect, useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate, Link } from "react-router-dom";

export default function Profil() {
  const { user } = useAuth();
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;

    const fetchUser = async () => {
      const ref = doc(db, "users", user.uid);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        setUserData(snap.data());
      }
    };

    fetchUser();
  }, [user]);

  const handleLogout = async () => {
    await signOut(getAuth());
    navigate("/");
  };

  if (!user) {
    return <div className="container py-5 text-center">Veuillez vous connecter pour accéder à votre profil.</div>;
  }

  return (
    <div className="container py-5" style={{ maxWidth: "600px" }}>
      <h3 className="mb-4">👤 Mon profil</h3>
      {userData ? (
        <div className="border rounded p-4 bg-light shadow-sm">
          <p><strong>Nom :</strong> {userData.prenom} {userData.nom}</p>
          <p><strong>Email :</strong> {userData.email}</p>
          <p><strong>WhatsApp :</strong> {userData.whatsapp}</p>
          <p><strong>Rôle :</strong> {userData.role}</p>

          <div className="mt-4 d-flex gap-2">
            <Link to="/favoris" className="btn btn-outline-primary">Voir mes favoris</Link>
            <button className="btn btn-outline-danger" onClick={handleLogout}>Se déconnecter</button>
          </div>
        </div>
      ) : (
        <p>Chargement des données utilisateur...</p>
      )}
    </div>
  );
}
